export default __webpack_public_path__ + "static/media/file.3ea7cb02.png";